import { GetServerSidePropsResult } from 'next';
import { Terms } from '../domains/terms';
import { getPageByHandle } from '../services/shopify/page';

import { PageLayout } from '../widgets';

interface PageProps {
  pageByHandle: any;
}

const TermsPage = ({ pageByHandle }): JSX.Element => (
  <PageLayout>
    <Terms pageByHandle={pageByHandle} />
  </PageLayout>
);

export async function getServerSideProps(): Promise<
  GetServerSidePropsResult<PageProps>
> {
  const { pageByHandle } = await getPageByHandle('terms-conditions');

  return {
    props: {
      pageByHandle,
    },
  };
}

export default TermsPage;
